import "./projects.scss";
import Card from "../../shares/Card/Card";
import projects from "../../services/mockdata";

function Projects() {
    return (
        <div className="projects" id="Projects">
            <h1 className="projects-title">
                My projects
            </h1>
            <div className="project-list">
                {projects.map(project => (
                    <Card data={project} key={project.id} />
                ))}
            </div>
        </div>
    )
}

export default Projects